<template>
  <footer class="site-footer">
    <div class="content-max-width footer-legal">
      <h1>Sign up for emails</h1>
      <div class="middle flex align-center justify-between">
        <news-letter />
        <!-- <div class="signup my-1 md:my-0">
          <input type="text" placeholder="Your email" />
          <a href="" class="button">Sign up</a>
        </div> -->
        <div class="partners">
          <img src="/images/icons/fn-logo.png" alt="" />
          <!-- <img src="/images/icons/snaze-logo.png" alt="" /> -->
          <img src="/images/icons/merc-logo.png" alt="" />
        </div>
      </div>
      <div class="end flex md:flex-row align-center justify-between">
        <div class="socials flex">
          <a v-if="socials.facebook" :href="socials.facebook" target="_blank">
            <div class="ico flex align-center justify-center">
              <img src="/images/icons/fb-white.png" alt="" />
            </div>
          </a>
          <a v-if="socials.instagram" :href="socials.instagram" target="_blank">
            <div class="ico flex align-center justify-center">
              <img src="/images/icons/instagram-white.png" alt="" />
            </div>
          </a>
          <!-- TODO : Youtube here -->
          <a v-if="socials.youtube" :href="socials.youtube" target="_blank">
            <div class="ico flex align-center justify-center icon-yt">
              <img src="/images/icons/youtube-white.png" alt="" />
            </div>
          </a>
        </div>
        <ul class="footer-navs flex">
          <li><a href="/">Home</a></li>
          <li><a href="/whats-on">What's on</a></li>
          <li><a href="/sponsors-supporters">Sponsors & Supporters</a></li>
          <li><a href="/news">Blog</a></li>
          <li><a href="/contact-us">Contact</a></li>
        </ul>
      </div>
      <div class="flex">
        <p class="copyright font-proxima">
          Copyright &copy; {{ getYear }} Seaweek
        </p>
        <a
          href="http://www.brownpaperbag.co.nz/"
          target="_blank"
          class="copyright font-proxima"
          >Web Design by Brownpaperbag
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
import NewsLetter from "../components/utils/Newsletter";
export default {
  components: {
    NewsLetter,
  },
  props: {
    socials : {
      type: Object,
      default: {}
    }
  },
  computed: {
    getYear() {
      const d = new Date();
      const n = d.getFullYear();
      return n;
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Footer.vue